import type { SigninSession } from "../../API/auth";

export const handleSigninVerification = (
  session: SigninSession,
  redirect?: string | null,
) => {
  const { token, role } = session;

  if (!token || !role) {
    throw new Error("The sign-in response is missing authentication details.");
  }

  const destination =
    redirect || `${process.env.REACT_APP_REDIRECT_URL}/workspace`;

  const url = new URL(destination);

  url.searchParams.set("token", token);
  url.searchParams.set("role", role);

  window.location.replace(url.toString());
};
